import React, {
  FunctionComponent,
  ReactElement,
  memo,
} from 'react';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router';

interface Success {
  title: string;
}

const Success: FunctionComponent<Success> = ({ title }): ReactElement => {
  const history = useHistory();

  return (
    <>
      <Result
        status="success"
        title={title}
        extra={
          <Button type="link" onClick={() => history.push('/')}>Homepage</Button>
        }
      />
    </>
  )
}

export default memo(Success);
